import { AttributeAssociationItem } from '../../pages/edge-definitions/edge-definition-helper';

export interface DictionaryIndex {
    id?: string;
    name: string;
    attributes?: string[];
    type: string;
    partialFilterTql?: string;
}

export const CUSTOM_INDEX_TYPE = {
    KEYWORD: 'Search Keyword',
};

export interface Attribute {
    id?: string;
    displayName?: string;
    defaultValue?: string;
    name: string;
    description?: string;
    datatype?: string;
    required?: boolean;
    precision?: number;
    enumValues?: string[];
    min?: number;
    max?: number;
    regex?: string;
    error?: boolean;
    fingerprintAttributes?: string[];
    dynamicName?: string;
    treeViewDisplayName?: string;
    referenceDictionaryName?: string;
}

export interface DictionaryAttribute {
    id?: string;
    displayName?: string;
    defaultValue?: string;
    name: string;
    description?: string;
    datatype?: string;
    required?: boolean;
    precision?: number;
    enumValues?: string[];
    min?: number;
    max?: number;
    regex?: string;
    attributes?: DictionaryAttribute[] | SubAttribute[];
    nodeAttributes?: DictionaryAttribute[] | SubAttribute[];
    error?: boolean;
    dynamicName?: string;
    treeViewDisplayName?: string;
    fingerprintAttributes?: string[];
    referenceDictionaryName?: string;
}

export interface SubAttribute {
    id?: string;
    // displayName: string;
    name: string;
    description?: string;
    datatype?: string;
    defaultValue?: string;
    required?: boolean;
    precision?: number;
    enumValues?: string[];
    min?: number;
    max?: number;
    regex?: string;
    nodeAttributes?: SubAttribute[];
    referenceDictionaryName?: string;
}

export interface DictionaryDetail {
    name?: string;
    description?: string;
    groupName?: string;
    undefinedAttributesAction?: string;
    layoutMetadata?: Record<string, any>;
}

export interface Dictionary {
    name: string;
    description?: string;
    groupName?: string;
    undefinedAttributesAction?: string;
    attributes?: DictionaryAttribute[];
    indexes?: DictionaryIndex[];
    layoutMetadata?: Record<string, any>;
    properties?: any;
}

export interface IFormInputs {
    name: string;
    description: string;
    groupName: string;
    undefinedAttributesAction: string;
    nodeColorAction?: string;
    properties?: AttributeAssociationItem[];
}

export interface IDataType {
    value: string;
    label: string;
    group?: string;
}
export interface ConditionItem {
    fromCol: string;
    toCol: string;
}

export interface EdgeDefinition {
    name: string;
    fromDictionary: string;
    toDictionary: string;
    condition: ConditionItem[];
}
